
















import Vue from "vue";
import Component from "vue-class-component";
import GroupItem from "@/components/group/item.vue";
import { Prop, Watch } from "vue-property-decorator";
import { AppSearchService } from "@/common/api";
import _debounce from "lodash/debounce";

@Component({
  name: "GroupIndex",
  components: {
    GroupItem,
  },
})
export default class GroupIndex extends Vue {
  @Prop({
    default: () => "",
  })
  keyword;
  public infiniteId = 0;

  public groups = [];
  public infiniteHandler: any;
  public params = {
    page: 1,
    perPage: 20,
  };

  created() {
    this.infiniteHandler = _debounce(async ($state) => {
      await this.getList($state);
    }, 500);
  }

  @Watch("keyword")
  changeSelected() {
    this.params.page = 1;
    this.groups = [];
    this.infiniteId += 1;
  }

  public async getList($state) {
    const keyword = this.keyword;
    const result = await AppSearchService.userSearchGroups({
      ...this.params,
      ...{ keyword: keyword },
    });

    if (result.data.groups.length > 0) {
      this.params.page += 1;
      this.groups.push(...result.data.groups);
      $state.loaded();
    } else {
      try {
        $state.complete();
      } catch (error) {
        console.log(error);
      }
    }
  }
}
